import type { ReactNode } from 'react';

export const MainContentArea = ({ children }: { children: ReactNode }) => {
  return <div className="flex-1 min-w-0 h-full overflow-y-auto overflow-x-hidden pt-10 md:pt-0">{children}</div>;
};
